var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSync = function SvgSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sync_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#275CDE",
    d: "M10.009 3.333v-2.5L6.675 4.167 10.01 7.5V5c2.758 0 5 2.242 5 5 0 .842-.209 1.642-.584 2.333l1.217 1.217A6.6 6.6 0 0 0 16.675 10a6.665 6.665 0 0 0-6.667-6.667m0 11.667c-2.759 0-5-2.242-5-5 0-.842.208-1.642.583-2.333L4.375 6.45A6.6 6.6 0 0 0 3.342 10a6.665 6.665 0 0 0 6.666 6.667v2.5l3.334-3.334-3.334-3.333z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sync_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgSync;